export const WP_PIXEL_ID = 'WP-ADS-PTURSEYJK';
